var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50059 8.55004L13.0023 1.0508L11.4823 0.142334L6.43976 8.55004H1.99642C1.66688 8.55004 1.35084 8.68095 1.11783 8.91397C0.884813 9.14698 0.753906 9.46302 0.753906 9.79255L0.753906 10.5685C0.753906 15.7718 1.9646 20.9027 4.29232 25.5563C4.39294 25.757 4.54739 25.9258 4.7384 26.0438C4.92942 26.1618 5.14948 26.2243 5.37399 26.2244H22.6454C23.1049 26.2244 23.5221 25.9664 23.7271 25.5546C26.0541 20.9011 27.2655 15.7696 27.2655 10.5667V9.79255C27.2655 9.46302 27.1346 9.14698 26.9016 8.91397C26.6686 8.68095 26.3525 8.55004 26.023 8.55004H21.5796L16.5371 0.142334L15.0171 1.0508L19.5188 8.55004H8.50059ZM13.126 20.9221V17.3872H9.5911V15.6198H13.126V12.0849H14.8934V15.6198H18.4283V17.3872H14.8934V20.9221H13.126Z",
    fill: "#292929"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e6d8b2029cdfa462513a05989ead9f8b.svg";
export { ForwardRef as ReactComponent };